import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'booking-app',
  brandName: 'booking-app',
  description: 'Sistema de agendamento',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Agenda e calendário',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Marcação de compromisso',
  },
  testimonials: [
    {
      name: 'Utilizador Genérico',
      role: 'Profissional',
      text: 'Este sistema de agendamento simplificou o meu trabalho diário. É intuitivo e eficaz.',
      image: testimonial1,
    },
    {
      name: 'Cliente Exemplo',
      role: 'Cliente',
      text: 'Marcar um horário nunca foi tão simples. O processo é rápido e recebo lembretes, o que é ótimo!',
      image: testimonial2,
    },
    {
      name: 'Gestor de Negócio',
      role: 'Administrador',
      text: 'Excelente ferramenta para otimizar a gestão de agendamentos e melhorar a relação com os clientes.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'profissional',
    professionals: 'profissionais',
    business: 'negócio',
    businesses: 'negócios',
    service: 'serviço',
    services: 'serviços',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'agendamento',
    appointments: 'agendamentos',
  },
  homepage: {
    hero: {
      badge: 'Solução Completa',
      title: 'Simplifique seus agendamentos com booking-app',
      description: 'Aumente a produtividade e ofereça a melhor experiência aos seus clientes com o booking-app.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '500+', label: 'Negócios' },
      { value: '50k+', label: 'Agendamentos' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Marcações por Telefone',
        description: 'Interromper atendimentos para atender chamadas resulta em clientes insatisfeitos e perda de concentração.',
        icon: 'PhoneCall',
        quote: {
          text: 'Perdemos tempo atendendo chamadas para agendamentos',
          author: 'Profissional',
          business: 'Negócio Local',
        },
      },
      {
        title: 'Tempo Perdido',
        description: 'Gerir horários manualmente consome tempo que poderia usar para atender mais clientes.',
        icon: 'Clock',
        stats: [
          { label: 'Tempo perdido por semana:', value: '5 horas' },
          { label: 'Clientes perdidos por mês:', value: '20+' },
        ],
      },
      {
        title: 'Clientes Ausentes',
        description: 'Faltas e cancelamentos de última hora causam prejuízos e horários vazios que poderiam ser preenchidos.',
        icon: 'Users',
        quote: {
          text: 'Sistema de agendamento online reduziu significativamente as faltas',
          author: 'Profissional',
          business: 'Negócio Moderno',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'booking-app: O seu assistente digital',
      description: 'Simplificamos a gestão do seu negócio para que possa focar-se no que realmente importa.',
      features: [
        {
          title: 'Agendamento Online 24/7',
          description: 'Os seus clientes podem marcar horários a qualquer momento, sem precisar telefonar.',
        },
        {
          title: 'Gestão de Clientes',
          description: 'Aceda ao histórico de agendamentos e preferências de cada cliente.',
        },
        {
          title: 'Lembretes Automáticos',
          description: 'Reduza as faltas com lembretes por email ou SMS.',
        },
      ],
    },
    testimonials: {
      title: 'O que os nossos clientes dizem',
      description: 'Profissionais que confiam no booking-app para crescer.',
    },
    finalCta: {
      title: 'Pronto para simplificar seus agendamentos?',
      description: 'Junte-se a profissionais que já estão a crescer com o booking-app.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Consultor',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
